import { infoTypes, sortTypes } from '../constants.js';
import normalizeLink from './normalize-link.js';

function sortArticles(articles, links, sortOption, infoOption) {
  if (sortOption === sortTypes.CUSTOM) {
    const orderMap = Object.fromEntries(
      links.map((item) => [normalizeLink(item.link), item.index]),
    );

    return articles.sort((a, b) => orderMap[a.path] - orderMap[b.path]);
  }

  const usePublishDate =
    infoOption === infoTypes.AUTHOR_AND_PUBLICATION_DATE ||
    infoOption === infoTypes.PUBLICATION_DATE;

  const getDate = (article) =>
    usePublishDate
      ? article.publicationDate
      : article.modifiedDate || article.publicationDate;

  const sortDirection = sortOption === sortTypes.OLDEST ? 1 : -1;

  return articles.sort((a, b) => (getDate(a) - getDate(b)) * sortDirection);
}

export default sortArticles;
